<script setup lang="ts">
import type { JobFilterComparison } from '@ironsight/types'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import { onMounted, ref } from 'vue'

interface Props {
  value: string
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
})

const emit = defineEmits<{
  (e: 'input', value: string): void
  (e: 'operation-change', value: JobFilterComparison): void
  (e: 'apply'): void
}>()

function handleInputChange(value: string) {
  emit('operation-change', 'Contains')
  emit('input', value)
}

const handleSearchByEmpty = () => {
  emit('operation-change', 'IsEmpty')
}

type VsTextInputInstance = InstanceType<typeof VsTextInput> & { focus?: () => void }

const searchInputRef = ref<VsTextInputInstance | null>(null)

function emitSearchByEmpty() {
  emit('input', '')
  handleSearchByEmpty()
  emit('apply')
}

onMounted(async () => {
  searchInputRef.value?.focus?.()
})
</script>

<template>
  <div class="filter-search">
    <vs-text-input
      ref="searchInputRef"
      :label="props.label"
      :value="props.value"
      autofocus
      append-icon="search"
      @input="handleInputChange"
    >
      <template #append>
        <v-icon>search</v-icon>
      </template>
    </vs-text-input>

    <v-list-item @click="emitSearchByEmpty">
      <v-list-item-content>
        <v-list-item-title>Is empty</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<style scoped>
.filter-search {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
}
</style>
